import { render, staticRenderFns } from "./RegionDeptView.vue?vue&type=template&id=67180d73&scoped=true&"
import script from "./RegionDeptView.vue?vue&type=script&lang=js&"
export * from "./RegionDeptView.vue?vue&type=script&lang=js&"
import style0 from "./RegionDeptView.vue?vue&type=style&index=0&id=67180d73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67180d73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67180d73')) {
      api.createRecord('67180d73', component.options)
    } else {
      api.reload('67180d73', component.options)
    }
    module.hot.accept("./RegionDeptView.vue?vue&type=template&id=67180d73&scoped=true&", function () {
      api.rerender('67180d73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/livedi/view/RegionDeptView.vue"
export default component.exports